import { Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { InputText } from 'primeng/inputtext'
import { DateTime } from 'luxon'

import { DetailMode } from '@app/components/generic/generic.constants'
import { ErrorComponent } from '../../generic/errors'

@Component({
  selector: 'app-voucher-code-field',
  templateUrl: 'voucher-code-field.component.html',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    FormsModule,
    InputText,
    ErrorComponent,
  ],
})
export class VoucherCodeFieldComponent implements OnChanges, OnInit {
  @Input() balzacCode?: string
  @Input() date?: string
  @Input() voucherCode?: string
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() voucherCodeChange = new EventEmitter<string | undefined>()

  public voucherMinLength = 18
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    this.resetMinimumLength()
  }

  ngOnChanges (changes: SimpleChanges<VoucherCodeFieldComponent>) {
    // changes made to balzac or date should trigger the voucher code to be recalculated
    if (this.mode === 'edition') {
      if (changes.balzacCode || changes.date) {
        this.rebuildVoucherCode()
        if (changes.balzacCode) {
          this.resetMinimumLength()
        }
      }
    }
    setTimeout(() => {
      this.voucherCodeChange.emit(this.voucherCode)
    })
  }

  /**
   * Generate the voucher code according to the format:
   * XXXXXX_YYYYMM_
   * - with XXXXXX being the balzac code entered (usually 7 characters but old books can have only 6)
   * - with YYYYMM being the year and month selected
   * - last characters left empty, to be filled by users
   */
  rebuildVoucherCode () {
    if (!this.date || !this.balzacCode) return
    const dateString = DateTime.fromISO(this.date).toFormat('yyyyMM')
    this.voucherCode = `${this.balzacCode}_${dateString}_`.toLocaleUpperCase()
  }

  // min. length validation rules depend on the length of the balzac code entered (can be 6 or 7)
  resetMinimumLength () {
    if (this.balzacCode?.length === 6) this.voucherMinLength = 17
    else this.voucherMinLength = 18
  }
}
